import { useCheckoutState } from '../../../utils/checkoutState';
import useScript from '../../../utils/useScript';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    amazon: any;
  }
}

export const useAmazonPaymentScript = () => useScript('https://static-eu.payments-amazon.com/checkout.js');

const AmazonPayment = () => {
  useAmazonPaymentScript();
  return null;
};

export const useAmazonPayment = () => {
  const { checkoutState, updatePaymentOption } = useCheckoutState();

  const redirectToAmazon = async ({ currentUrl }: { currentUrl: string }) => {
    if (!window.amazon) {
      return;
    }

    const { paymentOptionKey } = checkoutState.orderState.payment!.selected![0];

    const { sessionId, ...rest } = await updatePaymentOption({
      paymentOptionKey,
      specification: { initialization: { initializeSession: true } },
      currentUrl
    });

    window.amazon.Pay.initCheckout({
      createCheckoutSession: async () => sessionId,
      placement: 'Other',
      ...rest
    });
  };

  return { redirectToAmazon };
};

export const useAmazonPaymentAddressChange = () => {
  const { checkoutState } = useCheckoutState();
  const scriptLoadingPromiseRef = useAmazonPaymentScript();
  return async () => {
    await scriptLoadingPromiseRef.current;
    const sessionId = checkoutState.orderState.payment?.selected?.[0]?.configuration?.initializationData?.sessionId;
    window.amazon.Pay.changeShippingAddress({ amazonCheckoutSessionId: sessionId });
  };
};

export default AmazonPayment;
